(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jwe-collection-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jwe-collection-hero')) {
  customElements.define('jwe-collection-hero', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.jwe-kv__track');
      this.slides = [...this.querySelectorAll('.jwe-kv__slide')];
      if (this.slides.length < 2) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.index = 0;
      this.inView = true;
      this.hovered = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.playing = this.dataset.autoplay === 'true' && !this.motion.matches;
      this.toggle = this.querySelector('[data-kv-toggle]');
      this.dots = [...this.querySelectorAll('[data-kv-index]')];
      this.querySelector('.jwe-kv__controls').hidden = false;
      this.querySelector('[data-kv-prev]').addEventListener('click', () => this.move(this.index - 1, true), {signal});
      this.querySelector('[data-kv-next]').addEventListener('click', () => this.move(this.index + 1, true), {signal});
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.move(i, true), {signal}));
      this.toggle.addEventListener('click', () => {
        this.playing = !this.playing;
        this.updateToggle();
        this.schedule();
      }, {signal});
      this.track.addEventListener('pointerdown', () => this.stop(), {signal, passive:true});
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
          this.slides[this.index].querySelector('a').focus({preventScroll:true});
        }
      }, {signal});
      this.addEventListener('focusin', event => { if (event.target !== this.toggle) this.stop(); }, {signal});
      this.addEventListener('mouseenter', () => {this.hovered = true;this.schedule();}, {signal});
      this.addEventListener('mouseleave', () => {this.hovered = false;this.schedule();}, {signal});
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.sync(), 100);
      }, {signal, passive:true});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.motion.addEventListener('change', () => {if(this.motion.matches)this.stop();}, {signal});
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.schedule();
      }, {threshold:0.15});
      this.observer.observe(this);
      this.resizer = new ResizeObserver(() => this.move(this.index, false, 'instant'));
      this.resizer.observe(this.track);
      this.updateToggle();
      this.schedule();
    }
    move(index, manual = false, behavior) {
      if (manual) this.stop();
      this.index = (index + this.slides.length) % this.slides.length;
      const slide = this.slides[this.index];
      const left = this.track.scrollLeft + slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left - (this.track.clientWidth - slide.clientWidth) / 2;
      this.track.scrollTo({left, behavior:behavior || (this.motion.matches ? 'instant' : 'smooth')});
      this.updateDots(manual);
    }
    sync() {
      const center = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
      const distances = this.slides.map(slide => Math.abs(slide.getBoundingClientRect().left + slide.clientWidth / 2 - center));
      this.index = distances.indexOf(Math.min(...distances));
      this.updateDots(false);
    }
    updateDots(announce) {
      this.dots.forEach((dot, i) => {
        if(i === this.index)dot.setAttribute('aria-current','true');
        else dot.removeAttribute('aria-current');
      });
      if(announce)this.querySelector('[data-kv-status]').textContent = this.slides[this.index].getAttribute('aria-label');
    }
    stop() {
      this.playing = false;
      this.updateToggle();
      this.schedule();
    }
    updateToggle() {
      this.toggle.setAttribute('aria-label', this.playing ? this.dataset.pause : this.dataset.play);
      this.toggle.querySelector('span').textContent = this.playing ? 'Ⅱ' : '▶';
    }
    schedule() {
      clearInterval(this.timer);
      if(this.playing && this.inView && !this.hovered && !document.hidden) {
        this.timer = setInterval(() => this.move(this.index + 1), Number(this.dataset.interval) || 6000);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearInterval(this.timer);
      clearTimeout(this.scrollTimer);
      this.observer?.disconnect();
      this.resizer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jwe-header"]) return;
  try {
    
document.addEventListener('click', (event) => {
  document.querySelectorAll('.jwe-header-localization[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.jwe-header-localization[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jwe-home"] && !Shopify.designMode) return;
  try {
    
(() => {
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 const fine = matchMedia('(pointer: fine)');
 function setup() {
  document.querySelectorAll('[data-noir-root]').forEach(root => {
   if (root.dataset.noirReady) return;
   root.dataset.noirReady = 'true';
   const visual = root.querySelector('.noir-hero-visual');
   if (!visual) return;
   let frame;
   visual.addEventListener('pointermove', event => {
    if (reduced.matches || !fine.matches || root.dataset.noirMotion !== 'true') return;
    cancelAnimationFrame(frame);
    const box = visual.getBoundingClientRect();
    const x = ((event.clientX - box.left) / box.width - .5) * 9;
    const y = ((event.clientY - box.top) / box.height - .5) * 9;
    frame = requestAnimationFrame(() => { visual.style.setProperty('--noir-x', x + 'px'); visual.style.setProperty('--noir-y', y + 'px'); });
   });
   const reset = () => { cancelAnimationFrame(frame); visual.style.setProperty('--noir-x', '0px'); visual.style.setProperty('--noir-y', '0px'); };
   visual.addEventListener('pointerleave', reset);
   reduced.addEventListener('change', reset);
  });
 }
 setup();
 document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jwe-order-support"]) return;
  try {
    
(() => {
 const form=document.getElementById('JweOrderSupport');if(!form)return;
 const topic=form.querySelector('#SupportTopic'),order=form.querySelector('#SupportOrder'),sku=form.querySelector('#SupportSku');if(!topic)return;
 const params=new URL(location.href).searchParams;const reference=params.get('model');if(reference)sku.value=reference.slice(0,120);
 if(params.get('topic')==='product')topic.value='Product question';
 const sync=()=>{order.required=topic.value!=='Product question';};sync();topic.addEventListener('change',sync);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jwe-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jwe-watch-recommendations')) {
    customElements.define('jwe-watch-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const key = 'jwe-recently-viewed-v1';
        const current = this.dataset.handle;
        let previous = [];
        try {
          const saved = JSON.parse(sessionStorage.getItem(key) || '[]');
          if (Array.isArray(saved)) previous = [...new Set(saved.filter(h => typeof h === 'string' && /^[a-z0-9][a-z0-9-]{0,200}$/.test(h)))].filter(h => h !== current).slice(0, 8);
          sessionStorage.setItem(key, JSON.stringify([current, ...previous].slice(0, 9)));
        } catch (_) {}
        const work = () => {
          if (this.dataset.needsNative === 'true') this.loadNative();
          if (previous.length && this.querySelector('[data-jwe-recent]')) this.loadRecent(previous.slice(0, 4));
        };
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); work(); }
          }, { rootMargin: '700px' });
          this.observer.observe(this);
        } else work();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
      async getDocument(url) {
        const target = new URL(url, location.origin);
        if (target.origin !== location.origin) return null;
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview && /^\d+$/.test(preview)) target.searchParams.set('preview_theme_id', preview);
        const response = await fetch(target, { credentials: 'same-origin', signal: AbortSignal.timeout(10000) });
        if (!response.ok) return null;
        return new DOMParser().parseFromString(await response.text(), 'text/html');
      }
      async loadNative() {
        try {
          const doc = await this.getDocument(this.dataset.nativeUrl);
          const source = doc?.querySelector('[data-jwe-similar]');
          const destination = this.querySelector('[data-jwe-similar]');
          if (this.isConnected && source && !source.hidden && destination) {
            destination.replaceWith(source);
            document.dispatchEvent(new CustomEvent('jwe:cards:loaded'));
          }
        } catch (_) {}
      }
      async loadRecent(handles) {
        const results = await Promise.allSettled(handles.map(async handle => {
          const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
          const url = new URL(root + 'products/' + encodeURIComponent(handle), location.origin);
          url.searchParams.set('section_id', this.dataset.section);
          const doc = await this.getDocument(url);
          return doc?.querySelector('template[data-jwe-recent-current]')?.content.querySelector('.jwe-product-card');
        }));
        if (!this.isConnected) return;
        const cards = results.filter(r => r.status === 'fulfilled' && r.value).map(r => r.value);
        const grid = this.querySelector('[data-jwe-recent-grid]');
        if (grid && cards.length) {
          grid.replaceChildren(...cards);
          this.querySelector('[data-jwe-recent]').hidden = false;
          document.dispatchEvent(new CustomEvent('jwe:cards:loaded'));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
